import styled from 'styled-components';
import { colors } from '../../../utils/colors';
import { bootstrapMax, bootstrapMin } from '../../../utils/devices';

import imgLinkedin from '../../../assets/icons/social_media/linkedin.png';
import imgFacebook from '../../../assets/icons/social_media/facebook.png';
import imgInstagram from '../../../assets/icons/social_media/instagram.png';
import map from '../../../assets/imgs/map.png';
import mapMobile from '../../../assets/imgs/map-mobile.png';
import { Col, Row } from 'react-bootstrap';

export const ContactContainer = styled.div``;

export const ColStyled = styled(Col)`
  gap: 22px 0;

  @media ${bootstrapMin.lg} {
    align-items: flex-start !important;
  }
`;

export const Textsbody = styled.p`
  {
    font-family: 'Trade Gothic LT';
    text-align: start;
    font-size: 14px;
    margin-top: 15px;
    padding: 10px;
  }
  @media ${bootstrapMin.lg} {
    font-size: 21px;
  }
`;

export const Textslist = styled.ul`
  {
    font-family: 'Trade Gothic LT';
    text-align: start;
    font-size: 14px;
    margin-top: 15px;
    padding: 10px;
    padding-left: 40px;

  }
  @media ${bootstrapMin.lg} {
    font-size: 21px;
  }
`;

export const RowStyled = styled(Row)`
  @media ${bootstrapMax.sm} {
    padding: 0 8px;
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
`;

export const H2Typography = styled.h2`
  {
    font-family: 'Trade Gothic LT';
    font-size: 20px;
    line-height: 24px;
    color: #ffffff;
    margin: 20px;
    background-color: #4997d0;
    width: auto;
    padding: 10px 20px;
    border-radius: 10px;
    font-weight: 600;
    display: flex;
    justify-content: center;
  }
  @media ${bootstrapMin.lg} {
    font-size: 30px;
  }
`;

export const Programsimg = styled.img`
   {
    width: 100%;
  }
  @media ${bootstrapMax.lg} {
    width: 60%;
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 744px;
  display: flex;
  justify-content: center;

  & .green-button {
    height: 47px !important;

    @media ${bootstrapMin.lg} {
      height: 39px !important;
    }
  }
`;

export const ContainerSocialMedia = styled.div`
  display: flex;
  justify-content: center;
  gap: 50px;

  @media ${bootstrapMin.lg} {
    justify-content: flex-start;
    gap: 0 50px;
  }
`;

export const IconSocialMedia = styled.div`
  background-image: url(${({ facebook, instagram }) => {
    if (facebook) return imgFacebook;
    else if (instagram) return imgInstagram;
    else return imgLinkedin;
  }});
  background-size: contain;
  background-repeat: no-repeat;
  width: 27px;
  height: 27px;
`;

export const Map = styled.div`
  background-image: url(${mapMobile});
  background-repeat: no-repeat;
  height: 280px;
  width: 280px;

  @media ${bootstrapMin.lg} {
    background-image: url(${map});
    height: 455px;
    width: 100%;
  }
`;
